var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 79,
    height: 76,
    viewBox: "0 0 79 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_365",
    "data-name": "Groupe 365",
    transform: "translate(-1363 -5120)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    cx: 39.5,
    cy: 38,
    rx: 39.5,
    ry: 38,
    transform: "translate(1363 5120)",
    fill: "#b7e9ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_545",
    "data-name": "Trac\\xE9 545",
    d: "M44.408,3.9a3.909,3.909,0,0,0-3.9-3.9H3.9A3.91,3.91,0,0,0,0,3.9v26.02a3.909,3.909,0,0,0,3.9,3.9h36.6a3.909,3.909,0,0,0,3.9-3.9ZM2.6,4.429,15.133,16.853,2.6,29.385ZM22.287,20.281,4.455,2.6H39.966Zm-5.306-1.6,4.394,4.356a1.3,1.3,0,0,0,1.836,0l4.284-4.284L39.966,31.225H4.442Zm12.354-1.772L41.806,4.442V29.385Z",
    transform: "translate(1380.524 5139.717)",
    fill: "#3ac1ae"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.fc7c04504609aca8f9062ee252e2df1b.svg";
export { ForwardRef as ReactComponent };